<div class="flex-column gap-widget">
	<div class="bg-rounded pad-M">
		<app-application-data></app-application-data>
	</div>
	<div class="bg-rounded pad-M">
		<app-application-flow></app-application-flow>
	</div>
</div>
